import { helpers } from '@vuelidate/validators';
import { Nullish } from '../typescript';

const AMOUNT_EXP = /^\d*([,.]\d{1,2})?$/;

export const LICENCE_PLATE_REGEX = /^[A-Za-z0-9]{1,15}$/;
export const CHASSIS_NUMBER_REGEX = /^[A-HJ-NPR-Z0-9]{6,17}$/;

// eslint-disable-next-line max-len
export const BE_VAT_NUMBER_REGEX = /^ATU[0-9]{8}$|^BE0[0-9]{9}$|^BG[0-9]{9,10}$|^CY[0-9]{8}L$|^CZ[0-9]{8,10}$|^DE[0-9]{9}$|^DK?[0-9]{8}$|^EE[0-9]{9}$|^GR[0-9]{9}$|^EL[0-9]{9}$|^ES[0-9A-Z][0-9]{7}[0-9A-Z]$|^FI[0-9]{8}$|^FR[0-9A-Z]{2}[0-9]{9}$|^GB([0-9]{9}|([0-9]{12})|[A-Z]{2}[0-9]{3})$|^HU[0-9]{8}$|^IE[0-9]S[0-9]{5}L$|^IT[0-9]{11}$|^LT([0-9]{9}|[0-9]{12})$|^LU?[0-9]{8}$|^LV[0-9]{11}$|^MT[0-9]{8}$|^NL[0-9]{9}B[0-9]{2}$|^PL[0-9]{10}$|^PT[0-9]{9}$|^RO[0-9]{2}$|^SE[0-9]{12}$|^SI[0-9]{8}$|^SK[0-9]{10}$/;

export const beVatNumber = helpers.regex(BE_VAT_NUMBER_REGEX);

export function amount(value: string): boolean {
  return !value || AMOUNT_EXP.test(value);
}

const TEL_VALID_CHARS = /\+|\d*/g;
export const COUNTRY_PREFIX_EXP = /^\+\d{1,4}$/;
const BE_MOBILE_PREFIX_EXP = /^((\+|00)32|0)0?4/;
const NL_MOBILE_PREFIX_EXP = /^\+316|06/;
const LU_MOBILE_PREFIX_EXP = /^((\+|00)352)?6/;
const FR_MOBILE_PREFIX_EXP = /^((\+|00)33|0)[679]/;
const BE_MOBILE_EXP = new RegExp(`(${BE_MOBILE_PREFIX_EXP.source})[6789]\\d{7}$`);
const NL_MOBILE_EXP = new RegExp(`(${NL_MOBILE_PREFIX_EXP.source})\\d{8}$`);
const LU_MOBILE_EXP = new RegExp(`(${LU_MOBILE_PREFIX_EXP.source})[269]1\\d{6}$`);
const FR_MOBILE_EXP = new RegExp(`(${FR_MOBILE_PREFIX_EXP.source})\\d{8}$`);

export function extendedMobileValidation(value: Nullish<string>): boolean {
  const sanitized = value?.match(TEL_VALID_CHARS)?.join('') ?? '';
  if (BE_MOBILE_PREFIX_EXP.test(sanitized)) return BE_MOBILE_EXP.test(sanitized);
  if (NL_MOBILE_PREFIX_EXP.test(sanitized)) return NL_MOBILE_EXP.test(sanitized);
  if (LU_MOBILE_PREFIX_EXP.test(sanitized)) return LU_MOBILE_EXP.test(sanitized);
  if (FR_MOBILE_PREFIX_EXP.test(sanitized)) return FR_MOBILE_EXP.test(sanitized);
  return true;
}
